import React, {useEffect} from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import ReactGA from "react-ga4";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home.jsx";
import ContactUs from "./pages/ContactUs.jsx";
import LoanAgainstCars from "./pages/LoanAgainstCars.jsx";
import LoanAgainstJewelry from "./pages/LoanAgainstJewellery.jsx";
import LoanAgainstLuxuryWatches from "./pages/LoanAgainstLuxuryWatches.jsx";
import Blogs from "./pages/Blogs.jsx";
import BlogPost from "./components/BlogPost.jsx";
import ScrollToTop from "./components/ScrollToTop";
import "./App.css";

const queryClient = new QueryClient();

const GA_MEASUREMENT_ID = "G-VLZME5JLPP";

const App = () => {
  useEffect(() => {
      ReactGA.initialize(GA_MEASUREMENT_ID);
      ReactGA.send("pageview");
  }, []);

  return (
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <Router>
          <Navbar />
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/loan-against-cars" element={<LoanAgainstCars />} />
            <Route
              path="/loan-against-jewelry"
              element={<LoanAgainstJewelry />}
            />
            <Route
              path="/loan-against-luxury-watches"
              element={<LoanAgainstLuxuryWatches />}
            />
            <Route path="/blogs" element={<Blogs />} />
            <Route path="/blogs/:slug" element={<BlogPost />} />
          </Routes>
          <Footer />
        </Router>
      </QueryClientProvider>
    </HelmetProvider>
  );
};

export default App;
